class HimalayanParallax extends HTMLElement {
  #controller;
  #frame = 0;
  #image;
  #reducedMotion;

  connectedCallback() {
    this.#image = this.querySelector('img');
    if (!this.#image) return;
    this.#controller = new AbortController();
    const { signal } = this.#controller;
    this.#reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
    document.addEventListener('scroll', this.#schedule, { capture: true, passive: true, signal });
    window.addEventListener('resize', this.#schedule, { passive: true, signal });
    document.addEventListener('visibilitychange', this.#schedule, { signal });
    this.#reducedMotion.addEventListener('change', this.#schedule, { signal });
    this.#schedule();
  }

  disconnectedCallback() {
    this.#controller?.abort();
    cancelAnimationFrame(this.#frame);
    this.#frame = 0;
    this.#image?.style.removeProperty('transform');
  }

  #schedule = () => {
    if (this.#frame || document.hidden) return;
    this.#frame = requestAnimationFrame(this.#paint);
  };

  #paint = () => {
    this.#frame = 0;
    if (this.#reducedMotion.matches) {
      this.#image.style.removeProperty('transform');
      return;
    }
    const box = this.getBoundingClientRect();
    if (box.bottom < -120 || box.top > innerHeight + 120 || !box.height) return;
    const progress = (box.top + box.height / 2 - innerHeight / 2) / (innerHeight / 2 + box.height / 2);
    const depth = Math.min(10, Math.max(0, Number(this.dataset.depth) || 0));
    this.#image.style.transform = `translate3d(0, ${progress * depth}%, 0)`;
  };
}

if (!customElements.get('himalayan-parallax')) customElements.define('himalayan-parallax', HimalayanParallax);
